// ФАЙЛ: priorities.ts
// НАЗНАЧЕНИЕ: Табличные приоритеты и дефолтные зоны по типу плагина.
// Используются, когда бэкенд не передал zone/priority явно (старый клиент).

import type { ZoneId } from './types'

/**
 * Приоритет виджета внутри зоны при стекировании (выше — ближе к якорю).
 * Значения выровнены с планом миграции: drawing важнее poll, soundboard ниже.
 */
export const WIDGET_DEFAULT_PRIORITY: Record<string, number> = {
  donation_alert: 100, // полноэкранные алерты не зонируются, приоритет — на будущее
  drawing: 60,
  poll: 50,
  soundboard: 40,
}

/** Дефолтная зона по типу плагина — fallback при отсутствии явной zone. */
export const WIDGET_DEFAULT_ZONE: Record<string, ZoneId> = {
  poll: 'top-right',
  drawing: 'top-left',
  soundboard: 'bottom-right',
}

/** Приоритет по умолчанию для неизвестного типа виджета. */
export const FALLBACK_PRIORITY = 0

/** Зона по умолчанию для неизвестного типа виджета. */
export const FALLBACK_ZONE: ZoneId = 'top-right'

/** Возвращает приоритет для типа виджета, либо FALLBACK_PRIORITY. */
export function resolveWidgetPriority(type: string): number {
  return WIDGET_DEFAULT_PRIORITY[type] ?? FALLBACK_PRIORITY
}

/** Возвращает дефолтную зону для типа виджета, либо FALLBACK_ZONE. */
export function resolveWidgetDefaultZone(type: string): ZoneId {
  return WIDGET_DEFAULT_ZONE[type] ?? FALLBACK_ZONE
}
